import { HOUSING_TYPES } from "../../constants/housing";
import { WHICHENSURE_TYPES } from "../../constants/personaldata";

export const isHouse = housingType => housingType === HOUSING_TYPES.HOUSE;
export const isDepartament = housingType => housingType === HOUSING_TYPES.DEPARTMENT;
export const ensureHousing = whichEnsure => whichEnsure === WHICHENSURE_TYPES.HOUSING;
export const ensureAssets = whichEnsure => whichEnsure === WHICHENSURE_TYPES.ASSETS;
